if (!window.customElements.get('custom-accordion')) {
  class CustomAccordion extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        accordionRow: '.accordion_item',
        accordionTrigger: '.accordion-heading',
        accordionContentWrapper: '.accordion-more',
        accordionContent: '.accordion-more .accordion-content',
      };

      this.initialHeight = this.dataset.initialHeight;
      this.fullHeight = this.dataset.fullHeight;
      this.onlyTrigger = this.dataset.onlyTrigger == 'true';
      this.hasNested = this.dataset.hasNested == 'true';
      this.closeOnOutsideClick = this.dataset.closeOnOutsideClick == 'true';
      this.alterText = this.dataset.alterText;
      this.scrollOnClose = this.dataset.scrollOnClose == 'true';

      this.accordionRows = this.querySelectorAll(this.selectors.accordionRow);
      this.accordionTrigger = this.querySelectorAll(
        this.onlyTrigger ? this.selectors.accordionTrigger : this.selectors.accordionRow
      );
    }

    toggleAccordion(event) {
      event.stopPropagation();
      const target_row = event.target.closest(this.selectors.accordionRow);
      const header = this.querySelector('.accordion-heading');

      if (target_row) {
        if (target_row.classList.contains('active')) {
          this.close(target_row);
        } else {
          this.open(target_row);
        }
      }
    }

    open(row) {
      if (this.dataset.allowMultipleOpen == 'false')
        this.accordionRows.forEach((accordionRow) => this.close(accordionRow));
      if(this.alterText)
      {
        const trigger = row.querySelector(this.selectors.accordionTrigger)
        const target = trigger.querySelector('[data-text-target]') || trigger;
        target.textContent = this.alterText;
      }
      row.classList.add('active');
      const row_wrapper = row.querySelector(this.selectors.accordionContentWrapper);
      const row_content = row.querySelector(this.selectors.accordionContent);
      const height = this.fullHeight ? `${this.fullHeight}px` : `${row_content.offsetHeight}px`;
      row_wrapper.style.setProperty('max-height', height);


      if (this.hasNested) {
        const outer_row_wrapper = row.closest(this.selectors.accordionContentWrapper);
        if (!outer_row_wrapper) return;
        const outer_row_content = outer_row_wrapper.querySelector(this.selectors.accordionContent);
        outer_row_wrapper.style.setProperty(
          'max-height',
          outer_row_content.offsetHeight + row_content.offsetHeight + 'px'
        );
      }
    }

    close(row) {
      row.classList.remove('active');
      if(this.alterText)
      {
        const trigger = row.querySelector(this.selectors.accordionTrigger)
        const initialText = trigger.dataset.initialText;
        const target = trigger.querySelector('[data-text-target]') || trigger;
        if(initialText) target.textContent = initialText;
      }
      const row_wrapper = row.querySelector(this.selectors.accordionContentWrapper);

      if(this.scrollOnClose)
        this.closest(".accordion-scroll-target")
          .scrollIntoView({ behavior: 'smooth', block: 'start' });
      const height = this.initialHeight ? `${this.initialHeight}px` : '0px';
      row_wrapper.style.setProperty('max-height', height);
    }

    connectedCallback() {
      if (this.dataset.mobileOnly == 'true' && window.innerWidth < 990) {
        this.accordionTrigger.forEach((trigger, index) => {
          trigger.addEventListener('click', this.toggleAccordion.bind(this));
          if (trigger.dataset.initialOpenedIndex && trigger.dataset.initialOpenedIndex == index) {
            trigger.click();
          }
        });
      } else if (this.dataset.mobileOnly == 'false') {
        this.accordionTrigger.forEach((trigger, index) => {
          trigger.addEventListener('click', this.toggleAccordion.bind(this));
          if (trigger.dataset.initialOpenedIndex && trigger.dataset.initialOpenedIndex == index) {
            trigger.click();
          }
        });
      }
      this.accordionRows.forEach((row) => {
        if (row.getAttribute('data-default-closed') === 'true' && row.classList.contains('active') == false) {
          this.close(row);
        }
      });
      if (this.closeOnOutsideClick) {
        window.addEventListener('click', () => {
          this.accordionRows.forEach((row) => {
            if (row.classList.contains('active')) {
              this.close(row);
            }
          });
        });
      }
    }

    executeDefaultAccordionOpenState() {
      const accordionRows = this.querySelectorAll(this.selectors.accordionRow);
      accordionRows.forEach((row) => {
        if (row.getAttribute('data-default-closed') === 'true' && row.classList.contains('active') == false) {
          this.close(row);
        }
      });
    }

    disconnectedCallback() {
      this.accordionTrigger.forEach((trigger) => {
        trigger.removeEventListener('click', this.toggleAccordion);
      });
    }
  }

  window.customElements.define('custom-accordion', CustomAccordion);
}